import { TableViewTypes } from './actionTypes';

export const getTableViewList = (payload: any) => ({
  type: TableViewTypes.GET_TABLE_VIEWLIST,
  payload,
});

export const getTableViewListSuccess = (payload: any) => ({
  type: TableViewTypes.GET_TABLE_VIEWLIST_SUCCESS,
  payload,
});

export const getTableViewListFail = (error: any) => ({
  type: TableViewTypes.GET_TABLE_VIEWLIST_FAIL,
  payload: error,
});

export const createTableView = (payload: any) => {
  return {
    type: TableViewTypes.CREATE_TABLE_VIEW,
    payload,
  };
};

export const createTableViewSuccess = (payload: any) => {
  return {
    type: TableViewTypes.CREATE_TABLE_VIEW_SUCCESS,
    payload,
  };
};

export const createTableViewFail = (error: any) => {
  return {
    type: TableViewTypes.CREATE_TABLE_VIEW_FAIL,
    payload: error,
  };
};

export const updateTableView = (payload: any) => {
  return {
    type: TableViewTypes.UPDATE_TABLE_VIEW,
    payload,
  };
};

export const updateTableViewSuccess = (payload: any) => {
  return {
    type: TableViewTypes.UPDATE_TABLE_VIEW_SUCCESS,
    payload,
  };
};

export const updateTableViewFail = (error: any) => {
  return {
    type: TableViewTypes.UPDATE_TABLE_VIEW_FAIL,
    payload: error,
  };
};

export const deleteTableView = (payload: any) => {
  return {
    type: TableViewTypes.DELETE_TABLE_VIEW,
    payload,
  };
};

export const deleteTableViewSuccess = (payload: any) => {
  return {
    type: TableViewTypes.DELETE_TABLE_VIEW_SUCCESS,
    payload,
  };
};

export const deleteTableViewFail = (error: any) => {
  return {
    type: TableViewTypes.DELETE_TABLE_VIEW_FAIL,
    payload: error,
  };
};
